// Util to get syntax highlighting in GraphQL queries.
export const gql = (query: string) => query;
